export default {
  dateInput: {
    placeholder: "дд/мм/рррр",
    openCalendar: "Відкрити календар",
    invalid: "Неправильна дата: використовуйте дд/мм/рррр",
  },
  myProfile: "Мій Профіль",
  billing: "Оплата",
  success: "Успіх",
  error: "Помилка",
  ok: "OK",
  validationSaveFailedTitle: "Помилка валідації",
  validationSaveFailedIntro:
    "Запис не вдалося зберегти з таких причин:",
  validationSaveAnyway: "Зберегти все одно",
  validationUnderstood: "OK",
  expenseFileMissingTitle: "Related File не додано",
  expenseFileMissingText:
    "Ви зберігаєте без доданого Related File. Продовжити все одно?",
  expenseFileMissingCancel: "Скасувати",
  validationPendingAmountToApply: "У вас залишився нерозподілений залишок",
  contactOutsideOperationTitle: "Контакт поза операцією",
  shippingIncoherenceTitle: "Невідповідності в цьому відвантаженні",
  contactOutsideOperationText:
    "{contact} не бере участі в {operations}: це не клієнт, не постачальник і не контакт жодної витрати. Якщо платить або отримує третя сторона — це нормально; інакше перевірте контакт.",
  contactOutsideOperationCancel: "Перевірити",
  contactOutsideOperationBanner:
    "Цей запис застосовано до {operations}, але {contact} не бере участі в цій операції (не клієнт, не постачальник і не контакт жодної витрати). Перевірте, чи правильний контакт.",
  collectContactNotClientTitle: "Надходження не від клієнта",
  collectContactNotClientText:
    "{contact} не є клієнтом {operations}. Якщо за клієнта платить третя сторона — це нормально; інакше перевірте контакт.",
  collectOverPendingTitle: "Надходження перевищує залишок",
  collectOverPendingLine:
    "До {shipping} застосовано {applied}, а залишок {pending}: перевищення {excess}.",
  collectOverPendingFooter:
    "Якщо зберегти все одно, буде застосовано до суми залишку, а перевищення залишиться незастосованим як аванс на користь контакту.",
  collectOverPendingAlsoNoFile: "Крім того, у надходження немає файлу.",
  collectContactNotClientBanner:
    "Це надходження застосовано до {operations}, але {contact} не є клієнтом цієї операції. Перевірте, чи правильний контакт.",
  validationForceSaveSessionTitle: "Сесію завершено",
  validationForceSaveSessionText:
    "Не вдалося зберегти, бо сесія закінчилася. Оновіть сторінку або увійдіть знову й повторіть спробу.",
  validationForceSaveGenericText:
    "Не вдалося завершити примусове збереження. Перевірте з’єднання й спробуйте знову.",
  routerNavLoading: "Завантаження…",
  testEnvironmentBanner: "Тестова версія — локальне середовище",
  testEnvironmentBannerHosted:
    "Тестова версія — ви переглядаєте тестову копію (це не продакшн)",
  "systemFeaturesPermissionDeniedTitle": "Немає дозволу",
  "systemFeaturesPermissionDeniedText":
    "У вас немає дозволу вмикати або вимикати функції системи. Попросіть адміністратора надати «Access system features» (systemfeatures.access) для вашої ролі.",
  registerSuccessLogin: "Обліковий запис створено. Тепер можна увійти.",
  registerConfirmEmailSent:
    "Ми надіслали посилання на вашу електронну пошту ({email}) для підтвердження облікового запису. Якщо ви його не отримали, перевірте папку «Спам». Натисніть на посилання, щоб підтвердити обліковий запис.",
  forgotPassword: "Забули пароль?",
  passwordResetEmail: "Введіть свою електронну адресу, і ми надішлемо посилання для встановлення нового пароля.",
  passwordResetContinue: "Продовжити",
  emailSent: "Скинути пароль",
  correctEmail: "Ми надішлемо посилання для скидання пароля на {email}. Усе правильно?",
  sendEmail: "Надіслати лист",
  pleaseinsertemail: "Введіть електронну адресу, з якою ви реєструвалися, щоб перейти до свого застосунку.",
  goToMyApp: "Перейти до мого застосунку",
  seeDemo: "Переглянути демо",
  incorrectUserOrPassword: "Неправильний користувач або пароль",
  loginLocked: "Забагато спроб із неправильним паролем. Обліковий запис заблоковано; спробуйте знову через {minutes} хв.",
  accountconfirm: "Ваш обліковий запис підтверджено, тепер можна увійти.",
  getStarted: "Почати",

  // Register.vue (кореневі ключі для $t)
  name: "Ім'я",
  email: "Електронна пошта",
  password: "Пароль",
  businessName: "Назва бізнесу",
  login: "Увійти",
  confirmEmailText: "Перевірте пошту, щоб підтвердити обліковий запис",
  nameAlreadyTaken: "Ця назва вже зайнята",
  errorCheckingRestaurantName: "Не вдалося перевірити доступність назви",
  nameRequired: "Ім'я обов'язкове",
  countryRequired: "Країна обов'язкова",
  restaurantNameRequired: "Назва бізнесу обов'язкова",
  emailRequired: "Електронна пошта обов'язкова",
  emailInvalid: "Некоректна адреса електронної пошти",
  passwordRequired: "Пароль обов'язковий",
  userExists: "Обліковий запис із цією поштою вже існує",
  registerCompanyLinkPlaceholder: "Посилання на ваш бізнес (необов'язково)",
  registerHelpBusinessUrl:
    "Ми використовуємо назву вашого бізнесу в URL, за яким клієнти заходять у застосунок.",
  registerHelpDedicatedDbConfirm:
    "Після підтвердження електронної пошти буде створено окрему базу даних для вашого бізнесу (той самий користувач на цій інстанції та на новій).",
  registerHelpDedicatedDbImmediate:
    "Окрема база даних для вашого бізнесу створюється одразу (той самий користувач на цій інстанції та на новій).",
  registerHelpCompanyLink:
    "Вкажіть посилання на Instagram, Facebook або сайт, щоб ми могли згадувати вас у маркетингових кампаніях.",
  registerHelpEmailConfirmBusiness:
    "Ми надішлемо лист із посиланням для підтвердження облікового запису; база даних бізнесу створюється після підтвердження.",
  registerHelpEmailConfirmAny:
    "Ми надішлемо лист із посиланням для підтвердження облікового запису; увійти можна лише після підтвердження.",
  registerConfirmSpamP1:
    "Якщо не бачите листа, перевірте спам. Якщо не отримали повідомлення з кодом, зв'яжіться з нами для ручної активації. Напишіть на contact@gotake.it або у WhatsApp технічної підтримки, натисніть тут:",
  registerConfirmWhatsapp: "WhatsApp",

  nothingtosee: "Нічого не знайдено",
  logout: "Вийти",

  "Add new": "Додати новий",
  All: "Всі",

  // Tutorial translations

  // Operations Summary translations
  operationsSummary: {
    title: "Резюме Операцій",
    noOperations: "Немає майбутніх операцій",
    help: "Допомога щодо дат експорту",
    close: "Закрити",
    helpText: {
      title: "Критерії Класифікації",
      sections: {
        mainDates: {
          title: "Основні Дати Відвантаження",
          eta: "ETA (Estimated Time of Arrival): Очікувана дата прибуття судна/літака до порту призначення. Важливо для координації митного оформлення та отримання вантажу.",
          etd: "ETD (Estimated Time of Departure): Очікувана дата відправлення судна/літака з порту відправлення. Позначає початок міжнародного транзиту.",
        },
        cutOffs: {
          title: "Cut Offs (Закриття)",
          documents:
            "Cut Off Documents: Крайній термін подання експортної документації. Якщо не дотримано, відвантаження може бути виключено з рейсу.",
          physical:
            "Cut Off Physical: Крайній термін фізичної доставки вантажу до терміналу. Після цієї точки контейнер більше не може бути прийнятий.",
        },
        cargoMovements: {
          title: "Рухи Вантажу",
          loading:
            "Loading Date: День, коли вантаж завантажується на судно/літак. Збігається з операціями стивування в порту.",
          gateOut:
            "Gate Out: Дата, коли контейнер виходить зі складу до портового терміналу. Позначає початок зберігання перевізником.",
        },
        documentation: {
          title: "Комерційна Документація",
          dateReleased:
            "Date Released: Дата звільнення документів відвантаження. З цього моменту імпортер може керувати отриманням у пункті призначення.",
        },
        importPermits: {
          title: "Дозволи на Імпорт",
          expiration:
            "Import Permit Expiration: Дата закінчення дозволу. Якщо він закінчується до прибуття вантажу, він не може бути націоналізований.",
        },
        payments: {
          title: "Дати Платежів",
          paymentDate:
            "Payment Date: Дата, коли щось потрібно сплатити. Критично важливо для підтримки грошового потоку та уникнення штрафів.",
        },
      },
    },
    messages: {
      eta: {
        today:
          "🚢 <strong>Прибуття сьогодні!</strong> {count} {vessel} {verb} сьогодні до порту призначення. Час координувати митне оформлення та отримання вантажу.",
        tomorrow:
          "🚢 <strong>Прибуття завтра:</strong> {count} {vessel} {verb} завтра. Підготуйтеся до митного оформлення.",
        thisWeek:
          "🚢 <strong>Цього тижня:</strong> {count} {vessel} {verb} цього тижня. Координуйте з імпортером для отримання.",
      },
      etd: {
        today:
          "⚓ <strong>Відправлення сьогодні:</strong> {count} {vessel} {verb} сьогодні з порту відправлення. Міжнародний транзит розпочався.",
        tomorrow:
          "⚓ <strong>Відправлення завтра:</strong> {count} {vessel} {verb} завтра. Остання можливість завершити документацію.",
        thisWeek:
          "⚓ <strong>Цього тижня:</strong> {count} {vessel} {verb} цього тижня з порту відправлення.",
      },
      loading: {
        today:
          "📦 <strong>Завантаження сьогодні:</strong> {count} {container} {verb} сьогодні на судно. Операції стивування в порту.",
        tomorrow:
          "📦 <strong>Завантаження завтра:</strong> {count} {container} {verb} завтра.",
        thisWeek:
          "📦 <strong>Цього тижня:</strong> {count} {container} {verb} цього тижня.",
      },
      gateOut: {
        today:
          "🚛 <strong>Gate Out сьогодні:</strong> {count} {container} {verb} сьогодні зі складу до портового терміналу.",
        tomorrow:
          "🚛 <strong>Gate Out завтра:</strong> {count} {container} {verb} завтра до порту.",
        thisWeek:
          "🚛 <strong>Цього тижня:</strong> {count} {container} {verb} цього тижня до терміналу.",
      },
      payment: {
        today:
          "💰 <strong>Платіж сьогодні:</strong> {count} {payment} {verb} сьогодні. Увага! Перевірте статус очікуючих платежів.",
        tomorrow:
          "💰 <strong>Платіж завтра:</strong> {count} {payment} {verb} завтра. Підготуйтеся до здійснення платежів.",
        thisWeek:
          "💰 <strong>Цього тижня:</strong> {count} {payment} {verb} цього тижня.",
      },
      cutOffDocs: {
        today:
          "📄 <strong>Cut Off документів сьогодні:</strong> {count} {operation} {verb} закриття документів сьогодні. Остання можливість!",
        tomorrow:
          "📄 <strong>Cut Off документів завтра:</strong> {count} {operation} {verb} закриття документів завтра.",
        thisWeek:
          "📄 <strong>Цього тижня:</strong> {count} {operation} {verb} закриття документів цього тижня.",
      },
      cutOffPhysical: {
        today:
          "📦 <strong>Cut Off фізичний сьогодні:</strong> {count} {operation} {verb} фізичне закриття сьогодні. Остання можливість!",
        tomorrow:
          "📦 <strong>Cut Off фізичний завтра:</strong> {count} {operation} {verb} фізичне закриття завтра.",
        thisWeek:
          "📦 <strong>Цього тижня:</strong> {count} {operation} {verb} фізичне закриття цього тижня.",
      },
      dateReleased: {
        today:
          "📋 <strong>Документи звільнені сьогодні:</strong> {count} {document} {verb} сьогодні. Імпортер може керувати отриманням.",
        tomorrow:
          "📋 <strong>Документи завтра:</strong> {count} {document} {verb} завтра.",
        thisWeek:
          "📋 <strong>Цього тижня:</strong> {count} {document} {verb} цього тижня.",
      },
      importPermit: {
        today:
          "🛂 <strong>Дозволи закінчуються сьогодні:</strong> {count} {permit} {verb} сьогодні. Критично! Без дозволу не може бути націоналізований.",
        tomorrow:
          "🛂 <strong>Дозволи завтра:</strong> {count} {permit} {verb} завтра. Терміново поновіть.",
        thisWeek:
          "🛂 <strong>Цього тижня:</strong> {count} {permit} {verb} цього тижня.",
      },
    },
    words: {
      vessel: { single: "судно", plural: "судна" },
      container: { single: "контейнер", plural: "контейнери" },
      payment: { single: "платіж", plural: "платежі" },
      operation: { single: "операція", plural: "операції" },
      document: { single: "набір документів", plural: "набори документів" },
      permit: { single: "дозвіл", plural: "дозволи" },
      arrives: { single: "прибуває", plural: "прибувають" },
      leaves: { single: "відправляється", plural: "відправляються" },
      loads: { single: "завантажується", plural: "завантажуються" },
      goesOut: { single: "виходить", plural: "виходять" },
      expires: { single: "закінчується", plural: "закінчуються" },
      has: { single: "має", plural: "мають" },
      releases: { single: "звільняється", plural: "звільняються" },
    },
  },

  // Events Analyzer translations
  eventsAnalyzer: {
    pendingPayment: "Очікує оплати",
    viewDetails: "Переглянути деталі",
  },

  listTitleHidden: "Приховані",
  "Export to Excel": "Експорт у Excel",
  "Hide empty date": "Приховати без дати",
  "Actions": "Дії",
  "Debit": "Дебет",
  "Credit": "Кредит",
  "Attached File": "Прикріплений файл",
  "No transactions found matching your search": "Немає рухів, що відповідають пошуку",
  "Hide movements that have no date": "Приховати рухи без дати",
  "No payments found": "Платежів не знайдено",
  "No collects found": "Надходжень не знайдено",
  listTabActive: "Активні",
  listTabArchived: "Архівовані",
  listTabAll: "Усі",
  hide: "Приховати",
  hideInThisView: "Приховати в цьому вигляді",
  showInThisView: "Показати в цьому вигляді",
  HideSelected: "Приховати вибрані",
  ShowSelected: "Показати вибрані",

  treeEdit: {
    dragToMove: "Перетягніть, щоб перемістити",
    elementName: "Назва елемента",
    editElement: "Редагувати елемент",
    deleteElement: "Видалити цей елемент",

    accountingCode: "Бухгалтерський код для проводок",
    itemColor: "Колір елемента",
    itemColorHint:
      "Колір використовується як тло позначки, коли цей елемент з'являється у списку. Без кольору він показується сірим.",
    noColor: "Без кольору",
    listTranslationsSection: "Переклади за мовами (необов’язково)",
    listTranslationsHint:
      "Якщо заповнити мову, користувачі побачать цей текст у відповідній мові інтерфейсу. Залиште порожнім, щоб використовувати назву вище.",
  },
};
